import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import NoteForm from "../../components/Notes/NoteForm";

const NotesCreate = ({classes, ref_type, ref_id, user, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('default.new_note')}
        />

        <Paper>
            <CardContent>
                <NoteForm
                    ref_type={ref_type}
                    ref_id={ref_id}
                    user={user}
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default NotesCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/notes/Create.jsx